import { computed, Ref, unref } from 'vue';
import { skipToken, useQuery } from '@tanstack/vue-query';
import { fetchAppVersionFolders } from './report.endpoints';
import { foldersQueryKeys } from './folders.queryKeys';
import { TAppVersionFoldersPayload } from '../models/types';

export function useFetchAppVersionFolders(payloadRef: Ref<TAppVersionFoldersPayload | null>) {
  return useQuery({
    queryKey: computed(() => {
      const payload = unref(payloadRef);
      if (!payload) return foldersQueryKeys.all;
      return foldersQueryKeys.appVersion(payload.integrationId, payload.versionId, {
        complianceRequirementId: payload.complianceRequirementId,
        complianceRequirementItemId: payload.complianceRequirementItemId,
      });
    }),
    queryFn: computed(() => {
      const payload = unref(payloadRef);
      if (!payload) {
        return skipToken;
      }

      return () => fetchAppVersionFolders(payload);
    }),
  });
}
